import { render, staticRenderFns } from "./OnsiteDetailedView.vue?vue&type=template&id=032a3662&scoped=true"
import script from "./OnsiteDetailedView.vue?vue&type=script&lang=js"
export * from "./OnsiteDetailedView.vue?vue&type=script&lang=js"
import style0 from "./OnsiteDetailedView.vue?vue&type=style&index=0&id=032a3662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032a3662",
  null
  
)

export default component.exports